import React from 'react';
import { Routes, Route } from "react-router-dom";
import CaMakerReportsModule from "./ca-maker-reports-module/ca-maker-reports-module";

const Maker_Reports = () => {
  return (
    <Routes>
      <Route index element={<CaMakerReportsModule />} />
    </Routes>
  )
}

export default Maker_Reports;